/* eslint-disable */
// GENERATED by scripts/access/genPageCatalogue.mjs — do not edit.
// Route path -> the element router.tsx mounts there. Used to mount pages
// granted to an organisation by an `allow` row in dashboard_org_pages.
import type { ReactElement } from 'react'
import AdlHome from '../containers/adl-home'
import AdlILStats from '../containers/adlILStats'
import AllegiantHome from '../containers/allegiant'
import AllocateClaims from '../containers/allocateClaims'
import AllocateClaimsFull from '../containers/allocateClaimsFull'
import AnalyseSchema from '../containers/analyseSchema'
import ApprovedLenders from '../containers/approvedLenders'
import BulkActions from '../containers/bulkActions'
import CancellationReadiness from '../containers/cancellationReadiness'
import Cases from '../containers/cases'
import Chatbot from '../containers/chatbot'
import ClaimValuations from '../containers/claimValuations'
import Clients from '../containers/clients'
import ClientSchemaDetails from '../containers/clientSchemaDetails'
import ClientSearch from '../containers/clientSearch'
import CollectFundingClients from '../containers/collectFundingClients'
import CommsAgentActions from '../containers/commsAgentActions'
import CommsCategories from '../containers/commsCategories'
import CommsDocumentIngest from '../containers/commsDocumentIngest'
import CommsInboxRedirect from '../containers/commsInboxRedirect'
import CommsLocBatches from '../containers/commsLocBatches'
import CommsMailboxes from '../containers/commsMailboxes'
import CommsMailboxWorkspace from '../containers/commsMailboxWorkspace'
import CommsModels from '../containers/commsModels'
import CommsPipeline from '../containers/commsPipeline'
import CommsSearch from '../containers/commsSearch'
import Contracts from '../containers/contracts'
import CreateClient from '../containers/createClient'
import CronScrapers from '../containers/cronScrapers'
import DocumentBundleAccessBatch from '../containers/documentBundleAccessBatch'
import DocumentBundleAccessBatches from '../containers/documentBundleAccessBatches'
import DocumentBundleAccessDetail from '../containers/documentBundleAccessDetail'
import DocumentBundleAccessKeys from '../containers/documentBundleAccessKeys'
import DsarStats from '../containers/dsarStats'
import FairclaimApi from '../containers/fairclaimApi'
import FairClaimHome from '../containers/fairclaim-home'
import FFJApi from '../containers/ffjApi'
import Foa from '../containers/foa'
import FosCases from '../containers/fosCases'
import FosIntroducers from '../containers/fosIntroducers'
import FosTransfers from '../containers/fosTransfers'
import FundingBatchDetails from '../containers/fundingBatchDetails'
import FundingClientDetails from '../containers/fundingClientDetails'
import GorillaHome from '../containers/gorilla'
import Home from '../containers/home'
import ILAddClients from '../containers/ilAddClients'
import ILClientDetails from '../containers/ilClientDetails'
import ILManagement from '../containers/ilManagement'
import IneligibleFundingClients from '../containers/ineligibleFundingClients'
import InsuranceAudit from '../containers/insuranceAudit'
import InsuranceAuditAdmin from '../containers/insuranceAuditAdmin'
import InsuranceAuditClientDetails from '../containers/insuranceAuditClientDetails'
import IntroducedCases from '../containers/introducedCases'
import IntroducerFundingGap from '../containers/introducerFundingGap'
import IntroducersDirectory from '../containers/introducersDirectory'
import IntroducerStats from '../containers/introducer-stats'
import KnowledgeBase from '../containers/knowledgebase'
import LenderEdits from '../containers/lenderEdits'
import LenderFoaResponses from '../containers/foaResponse'
import LoaTracker from '../containers/loaTracker'
import LocStats from '../containers/locStats'
import MailReferralHome from '../containers/mr-home'
import MailReferralILStats from '../containers/mailReferralILStats'
import ManualAddClient from '../containers/manualAddClient'
import MBFCheckHome from '../containers/mbf-home'
import MfcHome from '../containers/mfc-home'
import MilitaryHearingLossAdmin from '../containers/militaryHearingLossAdmin'
import MilitaryHearingLossClientPage from '../containers/militaryHearingLossClient'
import MilitaryHearingLossHome from '../containers/militaryHearingLossHome'
import MilitaryHearingLossLeadsSearch from '../containers/militaryHearingLossLeadsSearch'
import MilitaryHearingLossLeadTracker from '../containers/militaryHearingLossLeadTracker'
import MilitaryHearingLossUsersPage from '../containers/militaryHearingLossUsers'
import MilitaryHearingLossWebsiteVisitors from '../containers/militaryHearingLossWebsiteVisitors'
import NeedsSortingClients from '../containers/needsSortingClients'
import OmnibusBatchVisibility from '../containers/omnibusBatchVisibility'
import OmnibusClaims from '../containers/omnibusClaims'
import OmnibusCommsUpload from '../containers/omnibusCommsUpload'
import OmnibusGroupDetail from '../containers/omnibusGroupDetail'
import PanacoHome from '../containers/panaco'
import PCPMO26Home from '../containers/pcpmo26-home'
import PcpReferralAddClient from '../containers/pcp-referral-add-client'
import PcpReferralEngagement from '../containers/pcp-referral-engagement'
import PcpReferralEngagementStats from '../containers/pcp-referral-engagement-stats'
import PcpReferralEsignHistory from '../containers/pcp-referral-esign-history'
import PcpReferralOverview from '../containers/pcp-referral-overview'
import PcpReferralTeamLeaderStats from '../containers/pcp-referral-team-leader-stats'
import PcpReferralUsers from '../containers/pcp-referral-users'
import Poc from '../containers/poc'
import Profile from '../containers/profile'
import ReEngagementOverview from '../containers/reEngagementOverview'
import ReEngagementSearch from '../containers/reEngagementSearch'
import ReportLinks from '../containers/reportLinks'
import SentinelHome from '../containers/sentinel-home'
import SentinelMattersHome from '../containers/sentinel-matters-home'
import SignatureReview from '../containers/signatureReview'
import SrdsClaim from '../containers/srdsClaim'
import SrdsClient from '../containers/srdsClient'
import SrdsHome from '../containers/srdsHome'
import StaffEmailSignature from '../containers/staffEmailSignature'
import StyleGuide from '../containers/styleGuide'
import UserActivity from '../containers/userActivity'
import Users from '../containers/users'
import ViewCase from '../containers/viewCase'
import ViewClient from '../containers/viewClient'
import ViewThruAllBatches from '../containers/viewThruAllBatches'
import ViewThruBatch from '../containers/viewThruBatch'
import ViewWebsiteClient from '../containers/viewWebsiteClient'
import VisionLaunchHome from '../containers/visionLaunch'
import WebsiteClaimsClients from '../containers/websiteClaimsClients'

export const PAGE_ELEMENTS: Record<string, ReactElement> = {
    '/adl-home': <AdlHome />,
    '/adl-il-stats': <AdlILStats />,
    '/admin/approved-lenders': <ApprovedLenders />,
    '/admin/batch-visibility': <OmnibusBatchVisibility />,
    '/admin/credit-scrapers': <CronScrapers />,
    '/admin/document-access': <DocumentBundleAccessBatches />,
    '/admin/document-access/access/:accessId': <DocumentBundleAccessDetail />,
    '/admin/document-access/batch/:batchGroup': <DocumentBundleAccessBatch />,
    '/admin/document-access/keys': <DocumentBundleAccessKeys />,
    '/admin/insurance-audit': <InsuranceAuditAdmin />,
    '/admin/omnibus-comms-upload': <OmnibusCommsUpload />,
    '/admin/style-guide': <StyleGuide />,
    '/admin/user-activity': <UserActivity />,
    '/allegiant-home': <AllegiantHome />,
    '/allocate-claims': <AllocateClaims />,
    '/allocate-claims-full': <AllocateClaimsFull />,
    '/analyse-schema': <AnalyseSchema />,
    '/analyse-schema/client/:clientKey': <ClientSchemaDetails />,
    '/bulk-actions': <BulkActions />,
    '/cancellation-readiness': <CancellationReadiness />,
    '/cases': <Cases />,
    '/chatbot': <Chatbot />,
    '/claim-valuations': <ClaimValuations />,
    '/client-search': <ClientSearch />,
    '/clients': <Clients />,
    '/collect-funding-clients': <CollectFundingClients />,
    '/comms/actions': <CommsAgentActions />,
    '/comms/categories': <CommsCategories />,
    '/comms/document-ingest': <CommsDocumentIngest />,
    '/comms/inbox': <CommsInboxRedirect />,
    '/comms/lenders': <LenderEdits />,
    '/comms/loc-batches': <CommsLocBatches />,
    '/comms/mailboxes': <CommsMailboxes />,
    '/comms/mailboxes/:address': <CommsMailboxWorkspace />,
    '/comms/models': <CommsModels />,
    '/comms/pipeline': <CommsPipeline />,
    '/comms/search': <CommsSearch />,
    '/contracts': <Contracts />,
    '/dsar-stats': <DsarStats />,
    '/fairclaim-api': <FairclaimApi />,
    '/fairclaim-api/keys': <FairclaimApi />,
    '/fairclaim-api/linked-funding': <FairclaimApi />,
    '/fairclaim-api/optics': <FairclaimApi />,
    '/fairclaim-api/test-suite': <FairclaimApi />,
    '/fairclaim-home': <FairClaimHome />,
    '/ffj-api': <FFJApi />,
    '/ffj-api/keys': <FFJApi />,
    '/ffj-api/linked-funding': <FFJApi />,
    '/ffj-api/optics': <FFJApi />,
    '/ffj-api/test-suite': <FFJApi />,
    '/FOA': <Foa />,
    '/foa-responses': <LenderFoaResponses />,
    '/FOS-imports': <FosCases />,
    '/FOS-introducers': <FosIntroducers />,
    '/FOS-transfers': <FosTransfers />,
    '/funding-batch/:batchId': <FundingBatchDetails />,
    '/funding-client/:clientId': <FundingClientDetails />,
    '/gorilla-home': <GorillaHome />,
    '/home': <Home />,
    '/il-add-clients': <ILAddClients />,
    '/il-client/:id': <ILClientDetails />,
    '/il-management': <ILManagement />,
    '/ineligible-funding-clients': <IneligibleFundingClients />,
    '/insurance-audit': <InsuranceAudit />,
    '/insurance-audit/client/:clientId': <InsuranceAuditClientDetails />,
    '/introducer-funding-gap': <IntroducerFundingGap />,
    '/introducers': <IntroducedCases />,
    '/introducers-directory': <IntroducersDirectory />,
    '/knowledge-base': <KnowledgeBase />,
    '/loa-tracker': <LoaTracker />,
    '/loc-stats': <LocStats />,
    '/mail-il-stats': <MailReferralILStats />,
    '/mail-referral-home': <MailReferralHome />,
    '/manual-add-client': <ManualAddClient />,
    '/mbfcheck-home': <MBFCheckHome />,
    '/media-claims': <WebsiteClaimsClients />,
    '/media-claims/add-client': <CreateClient />,
    '/media-claims/view-client/:url_client': <ViewWebsiteClient />,
    '/mfc-home': <MfcHome />,
    '/military-hearing-loss/add-client': <MilitaryHearingLossHome />,
    '/military-hearing-loss/admin': <MilitaryHearingLossAdmin />,
    '/military-hearing-loss/client/:clientId': <MilitaryHearingLossClientPage />,
    '/military-hearing-loss/lead-tracker': <MilitaryHearingLossLeadTracker />,
    '/military-hearing-loss/leads': <MilitaryHearingLossLeadsSearch />,
    '/military-hearing-loss/users': <MilitaryHearingLossUsersPage />,
    '/military-hearing-loss/website-visitors': <MilitaryHearingLossWebsiteVisitors />,
    '/needs-sorting-clients': <NeedsSortingClients />,
    '/omnibus-claims': <OmnibusClaims />,
    '/omnibus-claims/:omnibusId': <OmnibusGroupDetail />,
    '/panaco-home': <PanacoHome />,
    '/pcp-referral/add-client': <PcpReferralAddClient />,
    '/pcp-referral/engagement': <PcpReferralEngagement />,
    '/pcp-referral/engagement-stats': <PcpReferralEngagementStats />,
    '/pcp-referral/esign-history': <PcpReferralEsignHistory />,
    '/pcp-referral/overview': <PcpReferralOverview />,
    '/pcp-referral/team-stats': <PcpReferralTeamLeaderStats />,
    '/pcp-referral/users': <PcpReferralUsers />,
    '/pcpmo26-home': <PCPMO26Home />,
    '/POC': <Poc />,
    '/profile': <Profile />,
    '/re-engagement-overview': <ReEngagementOverview />,
    '/re-engagement-search': <ReEngagementSearch />,
    '/report-links': <ReportLinks />,
    '/sentinel-home': <SentinelHome />,
    '/sentinel-introducer-stats': <IntroducerStats />,
    '/sentinel-matters-home': <SentinelMattersHome />,
    '/signature-review': <SignatureReview />,
    '/srds-home': <SrdsHome />,
    '/srds/claim/:claimId': <SrdsClaim />,
    '/srds/client/:clientId': <SrdsClient />,
    '/staff-email-signature': <StaffEmailSignature />,
    '/users': <Users />,
    '/view-case/:url_case_ref': <ViewCase />,
    '/view-client/:url_client': <ViewClient />,
    '/viewthru-batch': <ViewThruBatch />,
    '/viewthru-batch/analysis': <ViewThruAllBatches />,
    '/vision-launch-home': <VisionLaunchHome />,
}
